import {  Component,  OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Profil} from '../../all-models';
import { SharedDataService, DebugService,PafListsService } from '../../all-services';

@Component({
  selector: 'debug-toolbar',
  templateUrl: './debug-toolbar.component.html',
  styleUrls: ['./debug-toolbar.component.scss']
})
export class DebugToolbarComponent implements OnInit {

  constructor(public sharedDataSvc: SharedDataService, public debugSvc:DebugService, private pafLists: PafListsService) {
   }

   private lstLoadedSubscription: Subscription = null;
  ngOnInit(): void {
  }


  ngOnDestroy():void{
      if (this.lstLoadedSubscription) this.lstLoadedSubscription.unsubscribe();
  }
  public get lstProfils():Profil[]{
    if (this.sharedDataSvc.portalType=="EXTRANET"){
      return this.debugSvc.lstProfils.filter(p=>p.Cod=='FOURNISSEUR');
    }
    else {
      return this.debugSvc.lstProfils;
    }
  }

  
  

}
